<template>
  <section>
    <h3>403 Forbidden</h3>
  </section>
</template>

<script>
export default {}
</script>
